import { eulaConfirmationRender } from 'eula-confirmation/eula-confirmation'

/***
 * We define all the boot functions for each landing page here
 */

export const bootFunctions = {
    indexEnterprisetermsredirect: function () {
        $('._submitEulaConfirmation').on('click', function () {
            eulaConfirmationRender();
        });
    },

    memberSignup: function () {
        $('#memberSignupForm #email').focus();
        window.initSignupForm($('#memberSignupForm'), ['input#password._passwordField', 'input#confirmPassword._confirmPasswordField'], function () {
            $('#captchaContainer').show();
        });

        $("[data-link-coupon-action]").click(function () {
            $(this).hide();
            $('#memberSignupForm .promoCode').show().find('#promoCode').focus();
        });
    },
    updateEmail: function () {
        $("a._submitEmail").on("click", function () {
            $('#memberUpdateEmailForm').submit(); return false;
        });
        $("#memberUpdateEmailForm").on("keypress", function (event) {
            window.checkForEnterKey(event, '_submitEmail');
        });
    },
    learnOffer: function () {
        $("[data-not-interested-action]").on("click", function (event) {
            window.plans.downgradePlan($(event.target).attr('data-free-plan-id')); 
            return false;
        });
    }
};
